import { SmsFunctionalityState } from 'apis/numbers';

/** Maps the text for the next state of sms_functionality */
export const smsFunctionalityStateText: Record<SmsFunctionalityState, string> =
  {
    activated: 'Request to deactivate',
    deactivated: 'Request to activate',
    pending_activation: 'Activation requested',
    pending_deactivation: 'Deactivation requested',
  };

/** Maps the next state when requesting a change of sms_functionality */
export function getNextFunctionalityState(
  state: SmsFunctionalityState,
): SmsFunctionalityState {
  switch (state) {
    case 'activated':
      return 'deactivated';
    case 'deactivated':
      return 'activated';
    default:
      throw new Error(`Invalid state: ${state}`);
  }
}
